var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { spendingTrendsCategoryColors } from '../../const/spending-trends';
import { colors } from '../../styles/theme';
export { trendsQuery, trendsQueryCacheKey } from './trends-query';
export var getCategoryTranslationLabel = function (category) {
    var formattedCategoryLabel = category
        .toLocaleLowerCase()
        .replaceAll(' ', '');
    return "spendingTrends.categoryLabel.".concat(formattedCategoryLabel);
};
export var addColoredBorder = function (tableData) {
    return tableData === null || tableData === void 0 ? void 0 : tableData.map(function (item) { return (__assign(__assign({}, item), { borderColor: spendingTrendsCategoryColors[item.category] || colors.trueBlack })); });
};
export var getSpendingTrends = function (data) {
    var spendings = data === null || data === void 0 ? void 0 : data.spendings[0];
    var updatedCategories = spendings === null || spendings === void 0 ? void 0 : spendings.spendingCategories.map(function (item) {
        return __assign(__assign({}, item), { percentage: "".concat(parseFloat(item.percentage).toFixed(2), "%") });
    });
    return __assign(__assign({}, spendings), { spendingCategories: updatedCategories });
};
//# sourceMappingURL=index.js.map